<script>
    import {createEventDispatcher} from 'svelte';

    import {url} from '@sveltech/routify';

    import Boton from "../../UI/Boton.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import Icono from "../../UI/Icono.svelte";
    import Tooltip from "../../UI/Tooltip.svelte";

    export let grupo;

    const dispatch = createEventDispatcher();

    const eliminarGrupo = () => dispatch('eliminar-grupo', grupo);

    let tooltip = false;
</script>

<style>
    .grupo {
        display: flex;
        align-items: center;
        padding-bottom: calc(var(--padding-global) / 4);
        margin-bottom: calc(var(--padding-global) / 4);
        border-bottom: 1px solid #efefef;
    }

    .trabajadores {
        font-size: .9em;
    }

    .acciones {
        margin-left: auto;
    }

    .calendario {
        position: relative;
        --color: var(--naranja);
        display: flex;
        align-items: center;
        margin-left: .5em;
    }

    .trabajadores {
        margin-left: .5em;
    }
</style>

<div class="grupo">
    <div class="nombre">
        <Subtitulo>{grupo.nombre}</Subtitulo>
    </div>
    {#if grupo.calendario}
        <div class="calendario" on:mouseover={() => tooltip = true}
             on:mouseleave={() => tooltip = false}>
            <Icono tamano="mediano">calendar_today</Icono>
            {#if tooltip}
                <Tooltip>Tiene calendario&nbsp;propio</Tooltip>
            {/if}
        </div>
    {/if}
    <div class="trabajadores">
        ({grupo.trabajadores} trabajador{grupo.trabajadores === 1 ? '' : 'es'})
    </div>

    <div class="acciones">
        <Boton href={$url(`/grupos/${grupo.id}`)} icono="info">Ver</Boton>
        <Boton href={$url(`/grupos/${grupo.id}/editar`)} icono="edit" tipo="ok">Editar</Boton>
        <Boton on:click={eliminarGrupo} icono="delete" tipo="peligro">Borrar</Boton>
    </div>
</div>